import { render } from "./editdevices.vue?vue&type=template&id=578e7b58&scoped=true"
import script from "./editdevices.vue?vue&type=script&lang=js"
export * from "./editdevices.vue?vue&type=script&lang=js"

import "./editdevices.vue?vue&type=style&index=0&id=578e7b58&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578e7b58"]])

export default __exports__